import time from "src/utils/time";

export default function getAgeForBirthdate(birthDate, t) {
  if (birthDate == null) return null;

  const ageDuration = time.duration(time().diff(birthDate));

  return ageDuration.format("y __ M __ d __", { onlyLargest: true });
}
